import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  uuid: "",
  title: "",
  number: null,
  description: "",

  // локальная загрузка изображений (DropZone)
  image_local: [],
  // ссылка на cloudinary
  image: "",

  price: null,
  capacity: null,

  bath_accessories: "",

  gallery: [],
  gallery_local: [],
  blocked_dates: []
}
const bath = createSlice({
  name: 'bath',
  initialState: initialState,
  reducers: {
    /** Сброс state */
    reset_bath(state) {
      Object.assign(state, initialState);
    },
    set_bath(state, action) {
      state = action.payload
      return state
    },
    set_title(state, action) {
      state.title = action.payload
    },
    set_number(state, action) {
      state.number = action.payload
    },
    set_description(state, action) {
      state.description = action.payload
    },
    set_price(state, action) {
      state.price = action.payload
    },
    set_image_local(state, action) {
      state.image_local = action.payload
    },
    set_image(state, action) {
      state.image = action.payload
    },
    set_bath_accessories(state, action) {
      state.bath_accessories = action.payload
    },
    set_gallery_local(state, action) {
      state.gallery_local = action.payload
    },
    set_gallery(state, action) {
      state.gallery = action.payload
    },
    set_capacity(state, action) {
      state.capacity = action.payload
    },
    set_blocked_dates(state, action) {
      state.blocked_dates = action.payload
    },
    delete_gallery_image(state, action) {
      state.gallery = state.gallery?.filter(item => item?.uuid !== action?.payload)
      return state
    },
  },
});

export const {
  reset_bath,
  set_bath,
  set_title,
  set_number,
  set_price,
  set_image_local,
  set_bath_accessories,
  set_capacity,
  set_image,
  set_gallery,
  set_gallery_local,
  delete_gallery_image,
  set_description,
  set_blocked_dates
} = bath.actions;

export default bath.reducer;
